var $7efe3ed02b9b9dd4$exports = {};
$7efe3ed02b9b9dd4$exports = {
    "Empty": `Tyhj\xe4`
};


export {$7efe3ed02b9b9dd4$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
